export enum HashimotoTestFieldEnum {
  TSH = 'TSH',
  FT3 = 'FT3',
  FT4 = 'FT4',
  ANTI_TPO = 'ANTI_TPO',
  ANTI_TG = 'ANTI_TG',
}

export type HashimotoTestInputType = {
  id?: number;
  tsh?: number;
  ft3?: number;
  ft4?: number;
  antiTpo?: number;
  antiTg?: number;
  testedAt: string;
};

export type HashimotoTestEdge = {
  node: HashimotoTestInputType;
};
